import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

const cardStyles = {

    views:{
      display: "flex", 
      justifyContent:"space-between",
      
    },
    views1:{
    

        objectFit:"scale-down",
              width:"200px",
              height:"300px",
              border: "solid 1px #CCC"
      }
  };

//https://mui.com/material-ui/react-image-list/
const  StandardImageList =({
   items})=> {
  return (
    
    
    <ImageList sx={{ height: 165 ,paddingTop:2}} cols={5} rowHeight={155}>
      {items.map((item) => (
       
       
       

        <ImageListItem key={item.shopId+"_"+item.trsnNo}>
          <img style={cardStyles.views}
            srcSet={`${item.imageUrl}?w=160&h=160&fit=crop&auto=format&dpr=2 2x`}
            src={`${item.imageUrl}?w=160&h=160&fit=crop&auto=format`}
            alt="California Nature"
            loading="lazy"
      
            
          />




        </ImageListItem>
      ))}
    </ImageList>
  );
}
export default StandardImageList;